import React from "react";
import styled from "styled-components";
import PageMenu from "./PageMenu";
import { Button } from "../Button";
import { ArrowForward, ShoppingCart } from "@material-ui/icons";
import { useDesktop } from "../Responsive";

const Wrapper = styled.div<{ padding?: string; dekstop: boolean }>`
  padding: ${(props) =>
  props.padding ? props.padding : props.dekstop ? "24px 32px" : "16px 16px"};
  border-right: 1px solid #eae5e5;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;

function PageWrapper({ children, menu, padding }: IPageWrapper) {
  const dekstop = useDesktop();

  return (
    <div
      style={{
        display: dekstop ? "flex" : "block",
        height: dekstop ? "99%" : "calc(100% - 52px)",
      }}
    >
      <Wrapper dekstop={dekstop} padding={padding}>
        {children}
      </Wrapper>
      {dekstop && <PageMenu>{menu}</PageMenu>}
    </div>
  );
}

export interface IPageWrapper {
  children: any;
  menu: any;
  padding?: string;
}

export default PageWrapper;
